/**
 * Search index — the named, locatable things the Search / Go To box looks
 * through. Charted objects carry their own name and position in the cells, but
 * the cells live in the map component's memory (loaded per provider/world), so
 * the map PUBLISHES a flat list of named places here once it has loaded them.
 * The Search sheet then reads this list (plus the user's own marks and routes
 * from the routing store) without needing the live map instance.
 *
 * Kept tiny and separate so a re-provider/re-world just republishes the list.
 */
import { create } from 'zustand';

export type SearchPlaceKind = 'place' | 'object';

export interface SearchPlace {
  /** Stable id from the source feature. */
  id: string;
  /** The charted name shown to the user. */
  name: string;
  /** A place (bay, sound, harbour, land area) or a charted object (buoy, light…). */
  kind: SearchPlaceKind;
  /** The S-57 object class, for a short descriptive sub-label. */
  objClass?: string;
  /** [lon, lat] WGS84. */
  position: [number, number];
}

interface SearchIndexState {
  /** Named, locatable places/objects from the loaded chart cells. */
  places: SearchPlace[];
  setPlaces: (places: SearchPlace[]) => void;
}

export const useSearchIndexStore = create<SearchIndexState>((set) => ({
  places: [],
  setPlaces: (places) => set({ places }),
}));
